import * as Utils from './stockUtils';
import createReducer from '../../../common/util/createReducer';
import {ActionTypes} from '../../actions';
import {downloadFile} from '../../../common/util/file';

const INITIAL_STATE = {
  'consulted': false,
  'generating': false,
  'loadingSuggestions': false,
  'loadingSOQResume': false,
  'checkingCode': false,
  'verifying': false,
  'suggestedOrders': [],
  'filteredOrders': [],
  'specialOrders': [],
  'provider': '',
  'partType': '',
  'iccFilter': '',
  'sccFilter': '',
  'partCodeFilter': '',
  'obsFilter': '',
  'SOQResume': {},
  'showBackOrderModal': false,
  'showOnOrderModal': false,
  'showSOQModal': false,
  'partCodeForStock': '',
  'partIndex': null,
  'partCode': '',
  'partName': '',
  'orderToDelete': null,
  'orderCode': '',
  'loadingMadStatus': false,
  'madStatus': {},
};

export const providerStockOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESTORE_PROVIDER_SUGGESTED_ORDERS]: (state, action) => ({
      ...INITIAL_STATE,
      'madStatus': state.madStatus || {},
    }),
    [ActionTypes.RESTORE_PROVIDER_MANUAL_ORDER]: (state, action) => ({
      ...state,
      'partCode': '',
      'partName': '',
    }),
    [ActionTypes.CHANGE_SUGGESTED_ORDER_PARAMETER]: (state, action) => ({
      ...state,
      [action.payload.name]: action.payload.value,
    }),
    [ActionTypes.CHANGE_SUGGESTED_ORDER_FILTER]: (state, action) => {
      const filters = {
        'iccFilter': state.iccFilter,
        'sccFilter': state.sccFilter,
        'partCodeFilter': state.partCodeFilter,
        'obsFilter': state.obsFilter,
      };
      filters[action.payload.name] = action.payload.value;

      return {
        ...state,
        'filteredOrders': Utils.filterCurrentOrders(
          state.suggestedOrders,
          filters
        ),
        [action.payload.name]: action.payload.value,
      };
    },
    [ActionTypes.GENERATE_PROVIDER_STOCK_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'generating': true,
    }),
    [ActionTypes.GENERATE_PROVIDER_STOCK_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'generating': false,
    }),
    [ActionTypes.GENERATE_PROVIDER_STOCK_ORDER_FAILED]: (state, action) => ({
      ...state,
      'generating': false,
    }),
    [ActionTypes.GET_PROVIDER_SUGGESTED_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loadingSuggestions': true,
    }),
    [ActionTypes.GET_PROVIDER_SUGGESTED_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'consulted': true,
      'loadingSuggestions': false,
      'orderCode': Utils.getOrderCode(action.response.jsonOrders),
      'suggestedOrders': action.response.jsonOrders,
      'filteredOrders': action.response.jsonOrders,
      'specialOrders': action.response.lastSpecialOrder,
    }),
    [ActionTypes.GET_PROVIDER_SUGGESTED_ORDER_FAILED]: (state, action) => ({
      ...state,
      'consulted': false,
      'loadingSuggestions': false,
      'orderCode': '',
      'suggestedOrders': [],
      'filteredOrders': [],
      'specialOrders': [],
    }),
    [ActionTypes.PROCESS_PROVIDER_STOCK_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loadingSuggestions': true,
    }),
    [ActionTypes.PROCESS_PROVIDER_STOCK_ORDER_SUCCESS]: (state, action) => {
      if (action.payload) {
        const updatedOrders = state.suggestedOrders.filter(
          (order) => !order.deleted
        );

        return {
          ...state,
          'loadingSuggestions': false,
          'suggestedOrders': updatedOrders,
          'filteredOrders': updatedOrders,
          'iccFilter': '',
          'sccFilter': '',
          'partCodeFilter': '',
          'obsFilter': '',
        };
      }

      downloadFile(action.response.data);
      return INITIAL_STATE;
    },
    [ActionTypes.PROCESS_PROVIDER_STOCK_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loadingSuggestions': false,
    }),
    [ActionTypes.CANCEL_PROVIDER_STOCK_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loadingSuggestions': true,
    }),
    [ActionTypes.CANCEL_PROVIDER_STOCK_ORDER_SUCCESS]: (state, action) =>
      INITIAL_STATE,
    [ActionTypes.CANCEL_PROVIDER_STOCK_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loadingSuggestions': false,
    }),
    [ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_REQUEST]: (state, action) => ({
      ...state,
      'checkingCode': true,
    }),
    [ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_SUCCESS]: (state, action) =>
      Utils.processCodeVerification(
        state,
        action.response.data,
        action.payload
      ),
    [ActionTypes.CHECK_PROVIDER_STOCK_ORDER_CODE_FAILED]: (state, action) => ({
      ...state,
      'checkingCode': false,
      'verifying': false,
    }),
    [ActionTypes.DELETE_PROVIDER_ORDER_PART_REQUEST]: (state, action) => ({
      ...state,
      'loadingSuggestions': true,
    }),
    [ActionTypes.DELETE_PROVIDER_ORDER_PART_SUCCESS]: (state, action) => ({
      ...state,
      'loadingSuggestions': false,
    }),
    [ActionTypes.DELETE_PROVIDER_ORDER_PART_FAILED]: (state, action) => ({
      ...state,
      'loadingSuggestions': false,
    }),
    [ActionTypes.GET_PART_SOQ_RESUME_REQUEST]: (state, action) => ({
      ...state,
      'loadingSOQResume': true,
    }),
    [ActionTypes.GET_PART_SOQ_RESUME_SUCCESS]: (state, action) => ({
      ...state,
      'loadingSOQResume': false,
      'SOQResume': action.response.data,
    }),
    [ActionTypes.GET_PART_SOQ_RESUME_FAILED]: (state, action) => ({
      ...state,
      'loadingSOQResume': false,
      'SOQResume': {},
    }),
    [ActionTypes.SORT_SUGGESTED_ORDER_ELEMENTS]: (state, action) => ({
      ...state,
      'filteredOrders': Utils.sortSuggestedOrder(
        state.filteredOrders,
        action.payload
      ),
    }),
    [ActionTypes.EDIT_SUGGESTED_ORDER_PART_CODE]: (state, action) => ({
      ...state,
      'suggestedOrders': Utils.updatePartCode(
        state.suggestedOrders,
        action.payload
      ),
      'filteredOrders': Utils.updatePartCode(
        state.filteredOrders,
        action.payload
      ),
      'verifying': true,
    }),
    [ActionTypes.EDIT_SUGGESTED_ORDER_PART_QUANTITY]: (state, action) => ({
      ...state,
      'suggestedOrders': Utils.updateOrderQuantity(
        state.suggestedOrders,
        action.payload
      ),
      'filteredOrders': Utils.updateOrderQuantity(
        state.filteredOrders,
        action.payload
      ),
    }),
    [ActionTypes.ADD_NEW_REGISTER_TO_SUGGESTED_ORDER]: (state, action) => ({
      ...state,
      ...Utils.addOrderElement(state),
    }),
    [ActionTypes.REMOVE_REGISTER_FROM_SUGGESTED_ORDER]: (state, action) => ({
      ...state,
      'suggestedOrders': Utils.removeOrderElement(
        state.suggestedOrders,
        action.payload
      ),
      'filteredOrders': Utils.removeOrderElement(
        state.filteredOrders,
        action.payload
      ),
    }),
    [ActionTypes.TOGGLE_DELETE_MARK_OF_SUGGESTED_ORDER_ELEMENT]: (
      state,
      action
    ) => ({
      ...state,
      'suggestedOrders': Utils.toggleDeleteMark(
        state.suggestedOrders,
        action.payload
      ),
      'filteredOrders': Utils.toggleDeleteMark(
        state.filteredOrders,
        action.payload
      ),
    }),
    [ActionTypes.SHOW_ORDER_PART_DETAILS]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [ActionTypes.HIDE_ORDER_PART_DETAILS]: (state, action) => ({
      ...state,
      'partCode': '',
      'partName': '',
    }),
    [ActionTypes.SHOW_ORDER_PART_ON_ORDER]: (state, action) => ({
      ...state,
      'showOnOrderModal': true,
      'partCodeForStock': action.payload,
    }),
    [ActionTypes.HIDE_ORDER_PART_ON_ORDER]: (state, action) => ({
      ...state,
      'showOnOrderModal': false,
      'partCodeForStock': '',
    }),
    [ActionTypes.SHOW_ORDER_PART_BACK_ORDER]: (state, action) => ({
      ...state,
      'showBackOrderModal': true,
      'partCodeForStock': action.payload,
    }),
    [ActionTypes.HIDE_ORDER_PART_BACK_ORDER]: (state, action) => ({
      ...state,
      'showBackOrderModal': false,
      'partCodeForStock': '',
    }),
    [ActionTypes.SHOW_ORDER_PART_SOQ_RESUME]: (state, action) => ({
      ...state,
      'showSOQModal': true,
      'partCodeForStock': action.payload,
    }),
    [ActionTypes.HIDE_ORDER_PART_SOQ_RESUME]: (state, action) => ({
      ...state,
      'showSOQModal': false,
      'partCodeForStock': '',
    }),
    [ActionTypes.CHECK_MAD_STATUS_REQUEST]: (state, action) => ({
      ...state,
      'loadingMadStatus': true,
    }),
    [ActionTypes.CHECK_MAD_STATUS_SUCCESS]: (state, action) => ({
      ...state,
      'loadingMadStatus': false,
      'madStatus': action.response.data,
    }),
    [ActionTypes.CHECK_MAD_STATUS_FAILED]: (state, action) => ({
      ...state,
      'loadingMadStatus': false,
    }),
  })(state, action);
};
